import React from 'react';
import { Navbar } from "./navbar";
import { Pipeline } from "../components/platform/Pipeline";

export function PlatformPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Navbar />

      {/* Hero */}
      <header className="text-center pt-16 pb-10 px-5">
        <p className="font-mono text-xs tracking-[0.28em] uppercase text-white/30">The Platform</p>
        <h1 className="mt-4 mx-auto max-w-3xl text-3xl md:text-5xl font-black tracking-tight leading-[1.1]">
          Your entire estate, replayable in four dimensions
        </h1>
        <p className="mt-4 mx-auto max-w-2xl text-white/60 text-base md:text-lg">
          Every database and lakehouse feeds one pipeline: sources converge, a world
          model generates the spatial view, fusion binds geometry to live truth, and
          deployment adds the time component.
        </p>
      </header>

      <main className="max-w-4xl mx-auto px-5 pb-16">
        <Pipeline />

        {/* Narrative copy */}
        <div className="mt-14 mb-14 max-w-3xl">
          <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight mb-4">
            One pipeline, four movements
          </h2>
          <p className="text-white/60 leading-8 text-[15px] mb-4">
            <b className="text-white font-semibold">Connect everything.</b> The ingestion bus
            speaks native protocol to every major warehouse, lakehouse, database and stream.
            No migration, no new stack: the platform comes to your data, wherever it lives.
          </p>
          <p className="text-white/60 leading-8 text-[15px] mb-4">
            <b className="text-white font-semibold">Generate the space.</b> If you have CAD or
            BIM, the world model uses it as scaffolding. If you don't, it reconstructs the
            environment from sensor and event geometry. Either way you get one consistent
            spatial view of every site in the estate — like the store above: orbit it, zoom
            it, watch shopper cohorts move through it.
          </p>
          <p className="text-white/60 leading-8 text-[15px] mb-4">
            <b className="text-white font-semibold">Fuse geometry truth.</b> The spatial view
            is pre-processed into point clouds or meshes, then every record from the
            warehouse is anchored to its exact position in the space. The result is a
            replica that is geometrically faithful and factually exact.
          </p>
          <p className="text-white/60 leading-8 text-[15px]">
            <b className="text-white font-semibold">Add time, and it comes alive.</b> Time is
            the final layer, and the point of everything before it. Once fused space is
            indexed across time, the past becomes replayable, the future becomes simulable,
            and any moment can be queried like a table.
          </p>
        </div>

        {/* CTA */}
        <div className="border border-white/10 rounded-2xl bg-white/[0.02] px-6 py-14 text-center mb-6">
          <h3 className="text-2xl font-extrabold tracking-tight">Point it at your stack</h3>
          <p className="mt-3 mx-auto max-w-md text-sm text-white/60 leading-7">
            A pilot connects your sources, generates your first spatial view, and puts a
            replayable replica of one site in your hands within weeks.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <a href="/#signup"
               className="inline-flex items-center justify-center px-7 py-3 rounded-lg bg-white text-black font-semibold text-sm hover:bg-white/90 transition-colors">
              Request early access →
            </a>
            <a href="/whitepapers"
               className="inline-flex items-center justify-center px-7 py-3 rounded-lg border border-white/25 text-white font-semibold text-sm hover:bg-white/10 transition-colors">
              Read the whitepaper
            </a>
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10 py-8 pb-12 text-center">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/30">
          Smarlytics · Connect → Generate → Fuse → Deploy
        </p>
      </footer>
    </div>
  );
}

export default PlatformPage;
